module.exports = __webpack_public_path__ + "static/media/03_01_07.416195e5.png";